import { render, staticRenderFns } from "./AccountAspGroup.vue?vue&type=template&id=dc65b736"
import script from "./AccountAspGroup.vue?vue&type=script&lang=js"
export * from "./AccountAspGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports